import { useMutation } from "@tanstack/react-query"
import { request } from "utils/request"

/**
 * @param {string} url The (new-arch) URL to connect to
 * @description checks if the specified name is already in use.
 * New-arch "check" endpoints answer 200 when the name is available and
 * 400 (with the reason in `message`) when it is taken or reserved.
 * @returns boolean
 */
export const useVerifyName = (url: string) => {
  const { data, mutateAsync, isLoading } = useMutation({
    mutationFn: async () => {
      try {
        const res = await request.get({ url }, "newArchAxiosInstance")
        return {
          status: false,
          message: res?.message,
        }
      } catch (error: any) {
        return {
          status: true,
          message: error?.response?.data?.message || error?.message,
        }
      }
    },
  })

  return { status: data, verify: mutateAsync, isVerifying: isLoading }
}
